import apis from "../utils/apiTil";
export default function caozuo(ids) {
    const roleId = window.sessionStorage.getItem('roleId');
    if (!roleId || roleId == undefined || roleId == '') return;
    return new Promise((resolve, reject) => {
        const { baseURL1 } = apis;
        baseURL1.get(`adminRoleMenu/getAllMenuByRoleId/${roleId}`).then(res => {
            if (res.data.code > 0) {
                return reject('您没有此权限！')
            }
            if (res.data.data.menuId == null) return
            if (res.data.data.menuId.length < 1) return
            if (!res.data.data.menuId.includes(',')) return
            const hr = res.data.data.menuId.split(",");
            const b = hr.filter(item => {
                return item == ids
            });
            if (b.length > 0) {
                return resolve(true)
            } else {
                return resolve(false)
            }

        })
    })
}
